<template>
    <div class="sustainable-component pot-individual-salary">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component pot-individual-salary</div>-->
        <div class="container-fluid p-0 pt-3">

            <div class="row mt-3" v-if="calculationType == '0'">

                <div class="col-12 col-md-8">

                    <div class="card px-3 py-5 rounded common-label-container">
                        <div class="common-label-tab-container rounded">
                            <div class="px-3 pt-1 rounded tab-contained" style="background-color: white">Konstruktion</div>
                        </div>
                        <div>
                            <!-- content -->
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12">

                                        <table class="table table-light table-hover table-striped">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="col-4">Faktor</th>
                                                    <th class="col-2">Grad</th>
                                                    <th class="col-2">Värde kr</th>
                                                    <th class="col-4">Nytt värde kr</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(factorGrade, index) in individualFactorGrades" :key="index">
                                                    <td>{{factorGrade.FactorName}}</td>
                                                    <td>{{factorGrade.GradeNumber}}</td>
                                                    <td><span v-decimal-text.max2="factorGrade.Salary"></span></td>
                                                    <td>
                                                        <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" v-model="factorGrade.PotSalary" hide-details="true" density="compact" variant="outlined"></v-text-field>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="saveEmployeeIndividualFactorGrades">
                                            Spara
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                            <!-- end content -->
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 mt-3 mt-md-0">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="ILDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="ILDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="calculationType == '1'">

                <div class="col-12 col-md-8 mt-3 pt-3">
                    <div class="card px-3 py-5 rounded common-label-container">
                        <div class="common-label-tab-container rounded">
                            <div class="px-3 pt-1 rounded tab-contained" style="background-color: white">Konstruktion</div>
                        </div>
                        <div>
                            <!-- content -->
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12">
                                        För att spara data klickar du antingen på ”Spara” som finns på respektive rad eller knappen
                                        "Skapa värden i lönesystemet" som finns under tabellen.

                                        <table class="table table-light table-hover table-striped">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th class="col-6">Poäng fr.o.m.</th>
                                                    <th class="col-2">Poäng t.o.m.</th>
                                                    <th class="col-3">Värde kr</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(interval, index) in salaryIntervals" :key="index">
                                                    <td>{{interval.From}}</td>
                                                    <td>{{interval.To}}</td>
                                                    <td><span v-decimal-text.max2="interval.Salary"></span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- end content -->
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 mt-3 mt-md-5">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="ILDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="ILDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>
            <div class="row" v-if="calculationType == '2'">
                <div class="col-12 col-md-8 mt-3">
                    <CommonLabelContainer title="Konstruktion">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col-12">
                                    Nuvarande värde <span v-decimal-text.max2="individualSalaryPerPoint"></span>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12">
                                    <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Värde per poäng" v-model="individualPotSalaryPerPoint" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="updateSalariesWithPoint">
                                        Spara
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </CommonLabelContainer>
                </div>
                <div class="col-12 col-md-4 mt-3 mt-md-3">
                    <div style="border: 1px solid #777777; background-color: White; padding: 10px;">
                        <p>Löneökning kr: <strong><span v-decimal-text.max2="ILDSalaryIncrease"></span></strong></p>
                        <p>Löneökning %: <strong><span v-decimal-text.max2="ILDSalaryIncreaseProcentage"></span></strong></p>
                    </div>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-12 col-md-8 mt-3">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="positions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12"><b>Utfall</b></div>
            </div>
            <div class="row">
                <div class="col-12 col-md-8 mr-3">
                    <table class="mt-2 table table-light table-hover table-striped">
                        <thead class="thead-light">

                            <tr>
                                <th class="col-1">Anst.nr.</th>
                                <th class="col-3">Namn</th>
                                <th class="col-3">Faktor</th>
                                <th class="col-1">Grad</th>
                                <th class="col-2">Värde kr</th>
                                <th class="col-2">Nytt värde kr</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in jobPositionEmployeesResult" :key="index">
                                <td v-if="row.EmployeeName == 'Summa'" colspan="4"><b>Summa</b></td>
                                <td v-if="row.EmployeeName == 'Summa'"><b><span v-decimal-text.max2="row.Salary"></span></b></td>
                                <td v-if="row.EmployeeName == 'Summa'"><b><span v-decimal-text.max2="row.PotSalary"></span></b></td>
                                <td v-if="row.EmployeeName != 'Summa'">{{row.EmployeeNumber}}</td>
                                <td v-if="row.EmployeeName != 'Summa'">{{row.EmployeeName}}</td>
                                <td v-if="row.EmployeeName != 'Summa'">{{row.IndividualFactorName}}</td>
                                <td v-if="row.EmployeeName != 'Summa'">{{row.GradeNumber}}</td>
                                <td v-if="row.EmployeeName != 'Summa'"><span v-decimal-text.max2="row.Salary"></span></td>
                                <td v-if="row.EmployeeName != 'Summa'"><span v-decimal-text.max2="row.PotSalary"></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <WagePotSalaryInterval v-bind:disabled="disabled" :model="model" ref="updatePotSalaryInterval" @updated="updateAfterChange"></WagePotSalaryInterval>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import { getCurrentInstance } from 'vue'
    import WagePotSalaryInterval from '../wagesetting/update/update-pot-salary-interval.vue'
    import CommonLabelContainer from "../../common/common-label-container";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'

    const updatePotSalaryInterval = ref(null);

    export default {
        emits: ['updated'],
        name: 'pot-individual-salary',
        components: {
            WagePotSalaryInterval,
            CommonLabelContainer,
            CommonSpinner
        },
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
           getId() {
                return getCurrentInstance().uid;
            },
            getAsSwedishNumberString(number) {
                return number.toString().replace(".", ",");
            },
            async updateSalariesWithPoint() {
                this.loading++;
                try {
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateAfterChange() {
                this.loading++;
                try {
                    await WageService.updateIndividualPotWagepart(false, this.calculationType, this.salary, this.individualPotSalaryPerPoint);
                    this.refreshIntervals();
                    this.getEmployeeIndividualFactorGrades();
                    this.getEmployeesWithIndividualFactors(this.selectedPosition);
                    this.loadPotDistribution();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getPositionsWithPoints() {
                this.loading++;
                try {
                    this.positions = await WageService.getPositionsWithPoints();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadIntervals() {
                this.loading++;
                try {
                    var tmp = await WageService.getIndividualSalaryIntervals();
                    this.salaryIntervals = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async refreshIntervals() {
                this.loading++;
                try {
                    if (this.calculationType == "1") {
                        this.loadIntervals();
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async saveEmployeeIndividualFactorGrades() {
                this.loading++;
                try {
                    try {
                        await WageService.updateEmployeeIndividualPotFactorGrades(this.individualFactorGrades);
                        this.updateAfterChange()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getEmployeeIndividualFactorGrades() {
                this.loading++;
                try {
                    var tmp = await WageService.getEmployeeIndividualFactorGrades();
                    var latestFactorName = null;
                    for (var i = 0; i < tmp.length; i++) {
                        if (tmp[i].FactorName != latestFactorName)
                            latestFactorName = tmp[i].FactorName;
                        else
                            tmp[i].FactorName = null;
                    }
                    this.individualFactorGrades = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getSalaryPart() {
                this.loading++;
                try {
                    var salaryPart = await WageService.getWagePartIndividual();
                    this.calculationType = salaryPart.CalculationType.toString();
                    this.individualSalaryPerPoint = salaryPart.IndividualSalaryPerPoint;
                    this.getEmployeeIndividualFactorGrades();
                    this.refreshIntervals();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getEmployeesWithIndividualFactors(positionid) {
                this.loading++;
                try {
                    var tmp = await WorkOrganisationService.getEmployeesWithIndividualFactors(positionid);
                    var latestName = null;
                    for (var i = 0; i < tmp.length; i++) {
                        if (tmp[i].EmployeeName != latestName)
                            latestName = tmp[i].EmployeeName;
                        else
                            tmp[i].EmployeeName = null;
                    }
                    this.jobPositionEmployeesResult = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadPotDistribution() {
                this.loading++;
                try {
                    var result = await WageService.getPotDistribution()
                    this.ILDSalaryIncrease = this.getAsSwedishNumberString(result.ILDSalaryIncrease);
                    this.ILDSalaryIncreaseProcentage = this.getAsSwedishNumberString(result.ILDSalaryIncreaseProcentage);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                salary: null,
                individualSalaryPerPoint: null,
                individualPotSalaryPerPoint:0,
                selectedPosition: null,
                salaryIntervals: [],
                individualFactorGrades: [],
                jobPositionEmployeesResult: [],
                calculationType: "0",
                positions: [],
                ILDSalaryIncrease: "0",
                ILDSalaryIncreaseProcentage: "0",
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.getEmployeesWithIndividualFactors(newVal);
            },

        },
        mounted() {
            this.getSalaryPart();
            this.getPositionsWithPoints();
            this.loadPotDistribution();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updatePotSalaryInterval }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
